import gql from 'graphql-tag';
import apolloClient from '../apollo';

/**
 * State
 */
const getDefaultState = () => {
  return {
    itemInventories: [],
    itemInventoryCount: 0,
  };
};
const state = getDefaultState();

/**
 * Defines the fields which are requested for an itemInventory
 * used for all queries which return an itemInventory
 * @type {DocumentNode}
 */
const ITEM_INVENTORY_REQUEST_FIELDS = gql`
  fragment itemInventoryFields on ItemInventory {
    _id
    item {
      number
      description
    }
    count
    project {
      number
      customer {
        lastname
        firstname
      }
    }
    storage {
      number
      name
      itemStorageType
    }
    createdAt
    updatedAt
  }
`;

/**
 * Actions
 */
const actions = {
  /**
   * Fetch a paginated, sorted and filtered itemInventory list
   * @param {*} param0
   * @param {*} payload
   */
  async fetchItemInventoriesPaginated({ commit, dispatch }, { pagination, sorting, filters }) {
    try {
      const response = await apolloClient.query({
        query: gql`
          query itemInventoriesPaginated(
            $pagination: PaginationInput
            $sorting: SortingInput
            $filters: ItemInventoryFilterInput
          ) {
            itemInventoriesPaginated(
              pagination: $pagination
              sorting: $sorting
              filters: $filters
            ) {
              itemInventories {
                ...itemInventoryFields
              }
              itemInventoryCount
            }
          }
          ${ITEM_INVENTORY_REQUEST_FIELDS}
        `,
        variables: {
          pagination: pagination,
          sorting: sorting,
          filters: filters,
        },
        fetchPolicy: 'network-only',
      });
      commit('SET_ITEM_INVENTORIES', response.data.itemInventoriesPaginated.itemInventories);
      commit('SET_ITEM_INVENTORY_COUNT', response.data.itemInventoriesPaginated.itemInventoryCount);
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  },
};

/**
 * Mutations
 */
const mutations = {
  SET_DEFAULT_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_ITEM_INVENTORIES: (state, itemInventories) =>
    itemInventories ? (state.itemInventories = itemInventories) : (state.itemInventories = []),
  SET_ITEM_INVENTORY_COUNT: (state, itemInventoryCount) =>
    (state.itemInventoryCount = itemInventoryCount),
};

/**
 * Getters
 */
const getters = {
  getItemInventories: (state) => state.itemInventories,
  getItemInventory: (state) => (itemInventoryId) =>
    state.itemInventories.find((itemInventory) => itemInventory._id == itemInventoryId),
  getItemInventoryCount: (state) => state.itemInventoryCount,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
